import type { BusinessScene } from './business-scene'

export interface BusinessContext {
  businessScene: BusinessScene
  capabilities: Record<string, boolean>
  userId?: string
  tenantId?: string
  fetchedAt: number
  expiresAt: number
}
let snapshot: { token: string; context: BusinessContext | null; nativeSupported: boolean } | null = null
export function normalizeBusinessContext(value: unknown): BusinessContext | null {
  const context = value as BusinessContext | null
  if (!context || !['UPSTREAM', 'LEGACY'].includes(context.businessScene)
    || !Number.isFinite(context.expiresAt) || context.expiresAt <= Date.now()
    || !Number.isFinite(context.fetchedAt) || context.fetchedAt > Date.now() + 60000) return null
  return { ...context, capabilities: context.capabilities || {} }
}
export function setBusinessContextSnapshot(token: string, context: unknown, nativeSupported: boolean): void {
  snapshot = { token, context: normalizeBusinessContext(context), nativeSupported }
}
export function getBusinessContextSnapshot(token: string | null) {
  if (!token || snapshot?.token !== token) return null
  return { ...snapshot, context: normalizeBusinessContext(snapshot.context) }
}
export function clearBusinessContextSnapshot(): void { snapshot = null }
